import DDSegment from '../DDSegment.vue'
import MMSegment from '../MMSegment.vue'
import YYYYSegment from '../YYYYSegment.vue'
import HHSegment from '../HHSegment.vue'
import MmMinuteSegment from '../mmMinuteSegment.vue'
import Separator from '../components/Separator.vue'
import PSpace from '../../../../../space/PSpace.vue'
import { PSpaceSize } from '../../../../../space/types'
import YYSegment from '../YYSegment.vue'

export const useFormatSegmentBuilder = () => {
  const parseFormat = (format: string): string[] => {
    return format.match(/(YYYY|YY|MM|DD|HH|mm|ss|.)/g) || []
  }

  const tokenToSegment = (token: string, defaultTime?: string, minuteIncrement?: number) => {
    switch (token) {
      case 'DD':
        return {
          component: DDSegment,
          props: {
            defaultTime: defaultTime,
          },
        }
      case 'MM':
        return {
          component: MMSegment,
          props: {
            defaultTime: defaultTime,
          },
        }
      case 'YYYY':
        return {
          component: YYYYSegment,
          props: {
            defaultTime: defaultTime,
          },
        }
      case 'YY':
        return {
          component: YYSegment,
          props: {
            defaultTime: defaultTime,
          },
        }
      case 'HH':
        return {
          component: HHSegment,
          props: {
            defaultTime: defaultTime,
          },
        }
      case 'mm':
        return {
          component: MmMinuteSegment,
          props: {
            defaultTime: defaultTime,
            minuteIncrement: minuteIncrement,
          },
        }
      case '/':
      case '.':
      case ':':
        return {
          component: Separator,
          props: { content: token },
        }
      case ' ':
        return {
          component: PSpace,
          props: { mobile: PSpaceSize.XS },
        }
      default:
        return null
    }
  }

  return {
    parseFormat,
    tokenToSegment,
  }
}
